<template>
  <div class="right">
    <div class="title-body">
      <div class="title-body-title">
        公司资质
        <div
          style="
            flex:1;
            height: 4px;
            margin-top: 18px;
            margin-left: 10px;
            background-image: url(./static/img/bar.png);
          "
        ></div>
      </div>
    </div>
    <div class="infomation">
      <div class="tableList" displaytitle="">
        <div
          class="el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition"
        >
          <div class="hidden-columns">
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div class="el-table__header-wrapper">
            <table
              cellspacing="0"
              cellpadding="0"
              border="0"
              class="el-table__header"
              style="width: 994px"
            >
              <colgroup>
                <col name="el-table_11_column_40" width="80" />
                <col name="el-table_11_column_41" width="457" />
                <col name="el-table_11_column_42" width="457" />
                <col name="gutter" width="0" />
              </colgroup>
              <thead class="has-gutter">
                <tr class="">
                  <th
                    colspan="1"
                    rowspan="1"
                    class="el-table_11_column_40 is-center is-leaf"
                    style="
                      background-color: rgb(241, 241, 241);
                      font-size: 16px;
                      font-weight: bold;
                      color: rgb(51, 51, 51);
                    "
                  >
                    <div class="cell">序号</div>
                  </th>
                  <th
                    colspan="1"
                    rowspan="1"
                    class="el-table_11_column_41 is-center is-leaf"
                    style="
                      background-color: rgb(241, 241, 241);
                      font-size: 16px;
                      font-weight: bold;
                      color: rgb(51, 51, 51);
                    "
                  >
                    <div class="cell">分类</div>
                  </th>
                  <th
                    colspan="1"
                    rowspan="1"
                    class="el-table_11_column_42 is-center is-leaf"
                    style="
                      background-color: rgb(241, 241, 241);
                      font-size: 16px;
                      font-weight: bold;
                      color: rgb(51, 51, 51);
                    "
                  >
                    <div class="cell">详情</div>
                  </th>
                  <th class="gutter" style="width: 0px; display: none"></th>
                </tr>
              </thead>
            </table>
          </div>
          <div class="el-table__body-wrapper is-scrolling-none">
            <table
              cellspacing="0"
              cellpadding="0"
              border="0"
              class="el-table__body"
              style="width: 994px"
            >
              <colgroup>
                <col name="el-table_11_column_40" width="80" />
                <col name="el-table_11_column_41" width="457" />
                <col name="el-table_11_column_42" width="457" />
              </colgroup>
              <tbody>
                <tr class="el-table__row">
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_11_column_40 is-center"
                  >
                    <div class="cell">1</div>
                  </td>
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_11_column_41 is-center"
                  >
                    <div class="cell">
                      <div style="display: inline-block">
                        <span>营业执照</span>
                        <!---->
                        <!---->
                        <!---->
                        <!---->
                      </div>
                    </div>
                  </td>
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_11_column_42 is-center"
                  >
                    <div class="cell">
                      <div style="display: inline-block">
                        <!---->
                        <div class="demo-image">
                          <img  v-viewer
                            :src="$config.IMG_URL+'/yyzz202511.png'"
                            alt=""
                          />
                        </div>
                        <!---->
                        <!---->
                        <!---->
                      </div>

                    </div>
                  </td>
                </tr>
                <tr class="el-table__row">
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_11_column_40 is-center"
                  >
                    <div class="cell">2</div>
                  </td>
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_11_column_41 is-center"
                  >
                    <div class="cell">
                      <div style="display: inline-block">
                        <span>保险中介许可证</span>
                        <!---->
                        <!---->
                        <!---->
                        <!---->
                      </div>
                    </div>
                  </td>
                  <td
                    rowspan="1"
                    colspan="1"
                    class="el-table_11_column_42 is-center"
                  >
                    <div class="cell">
                      <div style="display: inline-block">
                        <!---->
                        <div class="demo-image">
                          <img  v-viewer
                            :src="$config.IMG_URL+'/zjxkz2025.png'"
                            alt=""
                          />
                        </div>
                        <!---->
                        <!---->
                        <!---->
                      </div>

                    </div>
                  </td>
                </tr>

              </tbody>
            </table>
            <!----><!---->
          </div>
          <!----><!----><!----><!---->
          <div
            class="el-table__column-resize-proxy"
            style="display: none"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyInfo",
  components: {},
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style scoped lang="less">
@import "./../assets/table";
</style>



// WEBPACK FOOTER //
// src/pages/companyInfo.vue